import type { ImgHTMLAttributes } from 'react'
import { useTheme } from '@mui/material/styles'

type ImageSource = Pick<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet' | 'sizes'>
type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet' | 'sizes'> & {
  desktop: ImageSource
  mobile?: ImageSource
}

/** Let the browser select its source before hydration, including on cached HTML. */
const ResponsiveImage: React.FC<Props> = ({ desktop, mobile, ...props }) => {
  const theme = useTheme()
  return <picture>
    {mobile?.src && mobile.src !== desktop.src && <source
      media={theme.breakpoints.down('md').replace('@media ', '')}
      srcSet={mobile.srcSet || mobile.src}
      sizes={mobile.sizes}
    />}
    <img {...desktop} {...props} />
  </picture>
}

export default ResponsiveImage
